import { render, staticRenderFns } from "./TableSpecimensSpare.vue?vue&type=template&id=abaa4d16&scoped=true"
import script from "./TableSpecimensSpare.vue?vue&type=script&lang=js"
export * from "./TableSpecimensSpare.vue?vue&type=script&lang=js"
import style0 from "./TableSpecimensSpare.vue?vue&type=style&index=0&id=abaa4d16&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "abaa4d16",
  null
  
)

export default component.exports